import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isNil from 'lodash/isNil';
import { t } from '../../modules/infra/i18n';
import StripeInput from './StripeInput';

class CardInput extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    label: PropTypes.string,
    buttonText: PropTypes.string,
    disabled: PropTypes.bool,
  }

  static defaultProps = {
    label: null,
    buttonText: null,
    disabled: null,
  }

  getDisabled(processing) {
    if (isNil(this.props.disabled)) {
      return processing;
    }
    return this.props.disabled || processing;
  }

  handleSubmit = createToken => (e) => {
    e.preventDefault();
    createToken(async ({ id }) => this.props.onSubmit(id));
  };

  render() {
    return (
      <StripeInput>
        {(InputComponent, createToken, { error, processing }) => (
          <form onSubmit={this.handleSubmit(createToken)}>
            <label className="c-label-new u-block u-mb-" htmlFor="card-element">
              {this.props.label || t('common:card_input.default_label')}
            </label>
            <div className="o-flexbox">
              <div className="u-flex-1 u-pr">
                <InputComponent className="c-input c-input--white" disabled={this.getDisabled(processing)} />
              </div>
              <button className="c-btn c-btn--medium" disabled={this.getDisabled(processing)}>
                {this.props.buttonText || t('common:card_input.default_button_text')}
              </button>
            </div>
            <div className="epsilon u-font-color-red" role="alert" display-if={error}>
              {error}
            </div>
          </form>
        )}
      </StripeInput>
    );
  }
}

export default CardInput;
